// Formato fijo DD/MM/AAAA con cero a la izquierda.
// - Locale-independiente: NO usa toLocaleDateString (que en algunos navegadores/
//   OS reverte a MM/DD aunque se pase 'es-CR').
// - TZ-safe: si la entrada es un ISO string con prefijo YYYY-MM-DD, se extrae
//   la fecha del prefijo en lugar de pasarla por new Date(). Esto evita el
//   shift de -6h de UTC, que mostraba "ayer" para fechas guardadas como
//   medianoche UTC (la 1 de marzo 2026 a las 00:00Z se ve como 28 feb 18:00
//   en hora de Costa Rica).
// - Date objects: se usan componentes UTC para mantener la fecha tal cual.
export const formatFecha = (f) => {
  if (f == null || f === '') return '—';
  if (typeof f === 'string') {
    const m = f.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  }
  const d = f instanceof Date ? f : new Date(f);
  if (isNaN(d.getTime())) return '—';
  const dd = String(d.getUTCDate()).padStart(2, '0');
  const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
  const yyyy = d.getUTCFullYear();
  return `${dd}/${mm}/${yyyy}`;
};
